export default __webpack_public_path__ + "static/media/1854.02f002e2.png";